import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const SpinnerAnimatedIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={size}
        height={size}
        fill={color}>
        <path opacity={0.18}
            d="M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24"/>
        <path d="M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z">
            <animateTransform attributeName="transform"
                type="rotate"
                from="0 16 16"
                to="360 16 16"
                dur="0.8s"
                repeatCount="indefinite"/>
        </path>
    </svg>
);
SpinnerAnimatedIcon.displayName = 'SpinnerAnimatedIcon';
export default SpinnerAnimatedIcon;
